export const normalizeDropdownResponse = (rawData, endpoint) => {
  const apiFieldMap = {
    "/division": { label: "division_name", value: "id" },
    "/category": { label: "name", value: "id" },
    "/status": { label: "status_name", value: "id" },
    "/region": { label: "region_name", value: "id" },
    "/store": { label: "store_name", value: "id" },
    "/market": { label: "market_name", value: "id" },
    "/assigned_to": { label: "emp_name", value: "id" },
    "/admin": { label: "group_name", value: "group_id" },
    "/admin_group": { label: "group_name", value: "group_id" },
    "/jobtitle": { label: "job_title", value: "id" },
    "/department": { label: "department_name", value: "id" },
    "/employee": { label: "emp_name", value: "id" },
    "/company": { label: "company_name", value: "id" },
  };

  // 1. Try common keys
  const possibleKeys = ["data", "result", "records", "items", "list"];
  let list = Array.isArray(rawData)
    ? rawData
    : possibleKeys.reduce(
        (acc, k) => (Array.isArray(rawData?.[k]) ? rawData[k] : acc),
        []
      );

  // 2. Try nested array
  if (!Array.isArray(list) || list.length === 0) {
    for (const key of possibleKeys) {
      if (rawData?.[key] && typeof rawData[key] === "object") {
        const inner = Object.values(rawData[key]).find(Array.isArray);
        if (inner) {
          list = inner;
          break;
        }
      }
    }
  }

  if (!Array.isArray(list) || list.length === 0) return [];

  const mapping =
    Object.entries(apiFieldMap).find(([api]) => endpoint.includes(api))?.[1] || {};
  const sample = list[0];

  // --- Handle store, market, region with active filter ---
  if (endpoint.includes("/store")) {
    return list
      .filter((item) => item.active === 0) // only active
      .map((item) => ({
        label: item.store_name,
        value: item.id,
        sap: item.sap ?? null,       // add SAP
        active: item.active ?? 1,
        store_name: item.store_name,
      }));
  }

  if (endpoint.includes("/market")) {
    return list
      .filter((item) => item.active === 0)
      .map((item) => ({
        label: item.market_name,
        value: item.id,
        active: item.active ?? 1,
        market_name: item.market_name,
      }));
  }

  if (endpoint.includes("/region")) {
    return list
      .filter((item) => item.active === 0)
      .map((item) => ({
        label: item.region_name,
        value: item.id,
        active: item.active ?? 1,
        region_name: item.region_name,
      }));
  }

  // --- fallback for other endpoints (unchanged) ---
  // special handling for groups
  if ("group_name" in sample && "group_id" in sample) {
    return list.map((item) => ({
      label: item.group_name,
      value: item.group_id,
    }));
  }

  // special handling for employee
  if (sample.emp_name || (sample.first_name && sample.last_name)) {
    return list.map((emp) => ({
      label: emp.emp_name
        ? `${emp.emp_name} ${emp.employee_id}`
        : `${emp.first_name} ${emp.last_name} ${emp.employee_id}`,
      value: emp.id,
    }));
  }

  // dynamic label/value keys
  const labelKey =
    mapping.label ||
    ["division_name", "region_name", "store_name", "market_name", "name", "label"].find(
      (key) => key in sample
    ) ||
    "id";

  const valueKey =
    mapping.value ||
    ["id", "value", "code", "uuid", "group_id"].find((key) => key in sample) ||
    "id";

  return list.map((item, i) => ({
    label: item[labelKey] ?? `Option ${i + 1}`,
    value: item[valueKey] ?? i,
  }));
};
